// @ts-nocheck
/* eslint-disable */
import type { CalendarDate } from '@internationalized/date';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string in YYYY-MM-DD format */
  CalendarDate: { input: CalendarDate; output: CalendarDate; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: string; output: string; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type AdminCreateBillInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  amountDue: Scalars['Float']['input'];
  billSubmissionId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['CalendarDate']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  isAutopay?: InputMaybe<Scalars['Boolean']['input']>;
  lateFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  lateFeeDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  minAmountDue?: InputMaybe<Scalars['Float']['input']>;
  payerName?: InputMaybe<Scalars['String']['input']>;
  paymentUrl?: InputMaybe<Scalars['String']['input']>;
  previousAccountBalance?: InputMaybe<Scalars['Float']['input']>;
  providerEmail?: InputMaybe<Scalars['String']['input']>;
  providerName: Scalars['String']['input'];
  providerPhone?: InputMaybe<Scalars['String']['input']>;
  recurringTransactionId?: InputMaybe<Scalars['ID']['input']>;
  serviceEndDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  serviceStartDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  source: BillSource;
  statementDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  userId: Scalars['ID']['input'];
};

export type AdminCreateBillSubmissionInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  amountDue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  isAutopay?: InputMaybe<Scalars['Boolean']['input']>;
  lateFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  lateFeeDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  minAmountDue?: InputMaybe<Scalars['Float']['input']>;
  payerName?: InputMaybe<Scalars['String']['input']>;
  paymentUrl?: InputMaybe<Scalars['String']['input']>;
  previousAccountBalance?: InputMaybe<Scalars['Float']['input']>;
  providerEmail?: InputMaybe<Scalars['String']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  providerPhone?: InputMaybe<Scalars['String']['input']>;
  rawAmountDue?: InputMaybe<Scalars['String']['input']>;
  rawDueDate?: InputMaybe<Scalars['String']['input']>;
  rawJson?: InputMaybe<Scalars['JSONObject']['input']>;
  rawLateFeeAmount?: InputMaybe<Scalars['String']['input']>;
  rawLateFeeDate?: InputMaybe<Scalars['String']['input']>;
  rawMinAmountDue?: InputMaybe<Scalars['String']['input']>;
  rawPreviousAccountBalance?: InputMaybe<Scalars['String']['input']>;
  rawServiceEndDate?: InputMaybe<Scalars['String']['input']>;
  rawServiceStartDate?: InputMaybe<Scalars['String']['input']>;
  rawStatementDate?: InputMaybe<Scalars['String']['input']>;
  recurringTransactionId?: InputMaybe<Scalars['ID']['input']>;
  serviceEndDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  serviceStartDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  source: BillSubmissionSource;
  statementDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  status: BillSubmissionStatus;
  userId: Scalars['ID']['input'];
};

export type AdminCreateTransactionAnomalyFeedbackInput = {
  detailedReason?: InputMaybe<Scalars['String']['input']>;
  priority: TransactionAnomalyPriority;
  transactionIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AdminImpersonateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminImpersonateUserOutput = {
  __typename?: 'AdminImpersonateUserOutput';
  redirectUrl: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type AlphaAllowListEntry = {
  __typename?: 'AlphaAllowListEntry';
  addedByUserEmail?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  normalizedEmail: Scalars['String']['output'];
};

export type AnnouncePreReleaseResult = {
  __typename?: 'AnnouncePreReleaseResult';
  draftTag: Scalars['String']['output'];
  draftUrl: Scalars['String']['output'];
  slackMessageUrl?: Maybe<Scalars['String']['output']>;
};

export type AnomalyScoreParts = {
  __typename?: 'AnomalyScoreParts';
  baseScore: Scalars['Float']['output'];
  finalScore: Scalars['Float']['output'];
  financialAccountAdjustment: Scalars['Float']['output'];
  merchantAdjustment: Scalars['Float']['output'];
  timingAdjustment: Scalars['Float']['output'];
};

export type Bank = IEntity & INode & {
  __typename?: 'Bank';
  id: Scalars['ID']['output'];
  logoBase64Encoding?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
};

export type BankConnection = INode & {
  __typename?: 'BankConnection';
  accounts: Array<FinancialAccount>;
  bank: Bank;
  externalId: Scalars['String']['output'];
  hasPotentialSyncIssue: Scalars['Boolean']['output'];
  historicalSyncComplete: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user: User;
};

export type BankConnectionHealthStatus = {
  __typename?: 'BankConnectionHealthStatus';
  bankConnectionId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  neverSynced: Scalars['Boolean']['output'];
  plaidJSON?: Maybe<Scalars['JSONObject']['output']>;
  stale: Scalars['Boolean']['output'];
};

export type Bill = INode & {
  __typename?: 'Bill';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amountDue: Scalars['String']['output'];
  billSubmission?: Maybe<BillSubmission>;
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  dueDate: Scalars['CalendarDate']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isAutopay?: Maybe<Scalars['Boolean']['output']>;
  lateFeeAmount?: Maybe<Scalars['String']['output']>;
  lateFeeDate?: Maybe<Scalars['CalendarDate']['output']>;
  merchant?: Maybe<Merchant>;
  minAmountDue?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  previousAccountBalance?: Maybe<Scalars['String']['output']>;
  providerEmail?: Maybe<Scalars['String']['output']>;
  providerName: Scalars['String']['output'];
  providerPhone?: Maybe<Scalars['String']['output']>;
  recurringTransaction?: Maybe<RecurringTransaction>;
  senderIdentifier?: Maybe<Scalars['String']['output']>;
  serviceEndDate?: Maybe<Scalars['CalendarDate']['output']>;
  serviceStartDate?: Maybe<Scalars['CalendarDate']['output']>;
  source: BillSource;
  statementDate?: Maybe<Scalars['CalendarDate']['output']>;
  status: BillStatus;
  transactions: Array<Transaction>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Source of bill data */
export enum BillSource {
  Email = 'EMAIL',
  Sms = 'SMS',
  User = 'USER'
}

/** Status of a bill */
export enum BillStatus {
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Unpaid = 'UNPAID'
}

export type BillSubmission = INode & {
  __typename?: 'BillSubmission';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amountDue?: Maybe<Scalars['String']['output']>;
  bill?: Maybe<Bill>;
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  dueDate?: Maybe<Scalars['CalendarDate']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isAutopay?: Maybe<Scalars['Boolean']['output']>;
  lateFeeAmount?: Maybe<Scalars['String']['output']>;
  lateFeeDate?: Maybe<Scalars['CalendarDate']['output']>;
  minAmountDue?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  previousAccountBalance?: Maybe<Scalars['String']['output']>;
  providerEmail?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerPhone?: Maybe<Scalars['String']['output']>;
  rawAmountDue?: Maybe<Scalars['String']['output']>;
  rawDueDate?: Maybe<Scalars['String']['output']>;
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
  rawLateFeeAmount?: Maybe<Scalars['String']['output']>;
  rawLateFeeDate?: Maybe<Scalars['String']['output']>;
  rawMinAmountDue?: Maybe<Scalars['String']['output']>;
  rawPreviousAccountBalance?: Maybe<Scalars['String']['output']>;
  rawServiceEndDate?: Maybe<Scalars['String']['output']>;
  rawServiceStartDate?: Maybe<Scalars['String']['output']>;
  rawStatementDate?: Maybe<Scalars['String']['output']>;
  senderIdentifier?: Maybe<Scalars['String']['output']>;
  serviceEndDate?: Maybe<Scalars['CalendarDate']['output']>;
  serviceStartDate?: Maybe<Scalars['CalendarDate']['output']>;
  source: BillSubmissionSource;
  statementDate?: Maybe<Scalars['CalendarDate']['output']>;
  status: BillSubmissionStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Source of a bill submission */
export enum BillSubmissionSource {
  Email = 'EMAIL',
  Sms = 'SMS'
}

/** Status of a bill submission */
export enum BillSubmissionStatus {
  Converted = 'CONVERTED',
  NeedsReview = 'NEEDS_REVIEW',
  Rejected = 'REJECTED'
}

export type CreateFeatureGateInput = {
  audience?: InputMaybe<FeatureGateAudience>;
  defaultWhenError?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  ruleTree: Scalars['JSONObject']['input'];
};

export type DeleteReleaseDraftResult = {
  __typename?: 'DeleteReleaseDraftResult';
  deletedTag: Scalars['String']['output'];
};

export type Document = INode & {
  __typename?: 'Document';
  assetUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  emailMetadata?: Maybe<DocumentEmailMetadata>;
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type DocumentEmailMetadata = {
  __typename?: 'DocumentEmailMetadata';
  originalFrom?: Maybe<Scalars['String']['output']>;
  originalSubject?: Maybe<Scalars['String']['output']>;
  originalTo?: Maybe<Scalars['String']['output']>;
};

export type FeatureGate = {
  __typename?: 'FeatureGate';
  audience: FeatureGateAudience;
  createdAt: Scalars['DateTimeISO']['output'];
  defaultWhenError: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedByUserEmail?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ruleTree: Scalars['JSONObject']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Which surfaces a feature gate is exposed to. Server callers evaluate gates of every audience; the audience only constrains the client-bootstrap projection. */
export enum FeatureGateAudience {
  AllClients = 'ALL_CLIENTS',
  MopsWebClient = 'MOPS_WEB_CLIENT',
  ServerOnly = 'SERVER_ONLY',
  WebClient = 'WEB_CLIENT'
}

export type FinancialAccount = IEntity & INode & {
  __typename?: 'FinancialAccount';
  id: Scalars['ID']['output'];
  /** @deprecated This field will be removed in a future version */
  lastSyncedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  mask: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subtype: FinancialAccountSubtype;
  type: FinancialAccountPrimaryType;
};

export enum FinancialAccountPrimaryType {
  Credit = 'CREDIT',
  Depository = 'DEPOSITORY',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER',
  Payroll = 'PAYROLL'
}

export enum FinancialAccountSubtype {
  Auto = 'AUTO',
  Brokerage = 'BROKERAGE',
  Business = 'BUSINESS',
  CashIsa = 'CASH_ISA',
  CashManagement = 'CASH_MANAGEMENT',
  Cd = 'CD',
  Checking = 'CHECKING',
  Commercial = 'COMMERCIAL',
  Construction = 'CONSTRUCTION',
  Consumer = 'CONSUMER',
  CreditCard = 'CREDIT_CARD',
  CryptoExchange = 'CRYPTO_EXCHANGE',
  Ebt = 'EBT',
  EducationSavingsAccount = 'EDUCATION_SAVINGS_ACCOUNT',
  FixedAnnuity = 'FIXED_ANNUITY',
  Gic = 'GIC',
  HealthReimbursementArrangement = 'HEALTH_REIMBURSEMENT_ARRANGEMENT',
  HomeEquity = 'HOME_EQUITY',
  Hsa = 'HSA',
  Ira = 'IRA',
  Isa = 'ISA',
  Keogh = 'KEOGH',
  Lif = 'LIF',
  LifeInsurance = 'LIFE_INSURANCE',
  LineOfCredit = 'LINE_OF_CREDIT',
  Lira = 'LIRA',
  Loan = 'LOAN',
  Lrif = 'LRIF',
  Lrsp = 'LRSP',
  MoneyMarket = 'MONEY_MARKET',
  Mortgage = 'MORTGAGE',
  MutualFund = 'MUTUAL_FUND',
  NonCustodialWallet = 'NON_CUSTODIAL_WALLET',
  NonTaxableBrokerageAccount = 'NON_TAXABLE_BROKERAGE_ACCOUNT',
  Other = 'OTHER',
  OtherAnnuity = 'OTHER_ANNUITY',
  OtherInsurance = 'OTHER_INSURANCE',
  Overdraft = 'OVERDRAFT',
  Paypal = 'PAYPAL',
  Payroll = 'PAYROLL',
  Pension = 'PENSION',
  Plan_401A = 'PLAN_401A',
  Plan_401K = 'PLAN_401K',
  Plan_403B = 'PLAN_403B',
  Plan_457B = 'PLAN_457B',
  Plan_529 = 'PLAN_529',
  Prepaid = 'PREPAID',
  Prif = 'PRIF',
  ProfitSharingPlan = 'PROFIT_SHARING_PLAN',
  Qshr = 'QSHR',
  Rdsp = 'RDSP',
  Resp = 'RESP',
  Retirement = 'RETIREMENT',
  Rlif = 'RLIF',
  Roth = 'ROTH',
  Roth_401K = 'ROTH_401K',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  Sarsep = 'SARSEP',
  Savings = 'SAVINGS',
  SepIra = 'SEP_IRA',
  SimpleIra = 'SIMPLE_IRA',
  Sipp = 'SIPP',
  StockPlan = 'STOCK_PLAN',
  Student = 'STUDENT',
  Tfsa = 'TFSA',
  ThriftSavingsPlan = 'THRIFT_SAVINGS_PLAN',
  Trust = 'TRUST',
  Ugma = 'UGMA',
  Utma = 'UTMA',
  VariableAnnuity = 'VARIABLE_ANNUITY'
}

export type IEntity = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type INode = {
  id: Scalars['ID']['output'];
};

export type IProcessorStatusGqlConnection = {
  edges: Array<ProcessorStatusEdge>;
  pageInfo: PageInfo;
};

export type IProcessorStatusGqlEdge = {
  cursor: Scalars['String']['output'];
  node: ProcessorStatusGql;
};

export type ITransactionConnection = {
  edges: Array<TransactionEdge>;
  pageInfo: PageInfo;
};

export type ITransactionEdge = {
  cursor: Scalars['String']['output'];
  node: Transaction;
};

export type Merchant = IEntity & INode & {
  __typename?: 'Merchant';
  canonicalName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isIncomeSource: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  adminAddToAlphaAllowList?: Maybe<AlphaAllowListEntry>;
  adminAnnouncePreRelease: AnnouncePreReleaseResult;
  adminCreateBill: Bill;
  adminCreateBillSubmission: BillSubmission;
  adminCreateFeatureGate: FeatureGate;
  adminCreateTransactionAnomalyFeedback: Array<Transaction>;
  adminDeleteBankConnection: Scalars['String']['output'];
  adminDeleteBill: Scalars['String']['output'];
  adminDeleteBillSubmission: Scalars['String']['output'];
  adminDeleteFeatureGate: Scalars['Boolean']['output'];
  adminDeleteReleaseDraft: DeleteReleaseDraftResult;
  adminDeleteTransactionAnomalyFeedback: Transaction;
  adminImpersonateUser: AdminImpersonateUserOutput;
  adminPublishReleaseDraft: Release;
  adminReSyncFinancialData: BankConnection;
  adminRemoveFromAlphaAllowList: Scalars['Boolean']['output'];
  adminToggleFeatureGate: FeatureGate;
  adminUpdateFeatureGate: FeatureGate;
  adminUpdateProcessorStatus: ProcessorStatusGql;
};


export type MutationAdminAddToAlphaAllowListArgs = {
  email: Scalars['String']['input'];
};


export type MutationAdminAnnouncePreReleaseArgs = {
  expectedHeadSha: Scalars['String']['input'];
};


export type MutationAdminCreateBillArgs = {
  input: AdminCreateBillInput;
};


export type MutationAdminCreateBillSubmissionArgs = {
  input: AdminCreateBillSubmissionInput;
};


export type MutationAdminCreateFeatureGateArgs = {
  input: CreateFeatureGateInput;
};


export type MutationAdminCreateTransactionAnomalyFeedbackArgs = {
  input: AdminCreateTransactionAnomalyFeedbackInput;
};


export type MutationAdminDeleteBankConnectionArgs = {
  bankConnectionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminDeleteBillArgs = {
  billId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminDeleteBillSubmissionArgs = {
  billSubmissionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminDeleteFeatureGateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteReleaseDraftArgs = {
  expectedDraftTag: Scalars['String']['input'];
};


export type MutationAdminDeleteTransactionAnomalyFeedbackArgs = {
  transactionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminImpersonateUserArgs = {
  input: AdminImpersonateUserInput;
};


export type MutationAdminPublishReleaseDraftArgs = {
  expectedDraftTag: Scalars['String']['input'];
};


export type MutationAdminReSyncFinancialDataArgs = {
  bankConnectionId: Scalars['ID']['input'];
  resetCursor?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationAdminRemoveFromAlphaAllowListArgs = {
  normalizedEmail: Scalars['String']['input'];
};


export type MutationAdminToggleFeatureGateArgs = {
  id: Scalars['ID']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


export type MutationAdminUpdateFeatureGateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFeatureGateInput;
};


export type MutationAdminUpdateProcessorStatusArgs = {
  processorStatusId: Scalars['ID']['input'];
  status: ProcessorStatus;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PaginationDirection {
  Backward = 'BACKWARD',
  Forward = 'FORWARD'
}

export type PaginationInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: PaginationDirection;
  limit: Scalars['Int']['input'];
};

/** Status of a processor execution */
export enum ProcessorStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  FailedResolved = 'FAILED_RESOLVED',
  Running = 'RUNNING',
  Skipped = 'SKIPPED'
}

export type ProcessorStatusConnection = IProcessorStatusGqlConnection & {
  __typename?: 'ProcessorStatusConnection';
  edges: Array<ProcessorStatusEdge>;
  pageInfo: PageInfo;
};

export type ProcessorStatusEdge = IProcessorStatusGqlEdge & {
  __typename?: 'ProcessorStatusEdge';
  cursor: Scalars['String']['output'];
  node: ProcessorStatusGql;
};

export type ProcessorStatusFilters = {
  status?: InputMaybe<ProcessorStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
  webhookCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorStatusGql = INode & {
  __typename?: 'ProcessorStatusGQL';
  bankConnection?: Maybe<BankConnection>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalBankConnectionId: Scalars['String']['output'];
  finishTime?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
  startTime: Scalars['DateTimeISO']['output'];
  status: ProcessorStatus;
  user?: Maybe<User>;
  webhookCode: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  adminCurrentUser: User;
  adminEnabledFeatureGates: Array<Scalars['String']['output']>;
  adminGetAllWebhookCodes: Array<Scalars['String']['output']>;
  adminGetBankConnectionsHealth: Array<BankConnectionHealthStatus>;
  adminGetCurrentReleaseDraft?: Maybe<ReleaseDraft>;
  adminGetFeatureGate?: Maybe<FeatureGate>;
  adminGetFeatureGateByName?: Maybe<FeatureGate>;
  adminGetLatestTransactionMerchantStatistics: Array<TransactionMerchantStatistics>;
  adminGetLatestTransactionStatistics?: Maybe<TransactionStatistics>;
  adminGetProcessorStatuses: ProcessorStatusConnection;
  adminGetRecentAlphaAllowListEntries: Array<AlphaAllowListEntry>;
  adminGetReleaseChangeLog: ReleaseChangeLog;
  adminGetReleasePreview: ReleasePreview;
  adminGetTransactionPairsForUser: Array<TransactionPair>;
  adminGetTransactionsForUser: TransactionConnection;
  adminGetUser?: Maybe<User>;
  adminGetUserBankConnections: Array<BankConnection>;
  adminGetUsersWithTransactionReviewCounts: Array<UserWithTransactionReviewCount>;
  adminListBillSubmissions: Array<BillSubmission>;
  adminListBills: Array<Bill>;
  adminListFeatureGates: Array<FeatureGate>;
  adminListMerchants: Array<Merchant>;
  adminListRecurringTransactions: Array<RecurringTransaction>;
  adminListReleases: Array<Release>;
  adminListUsers: Array<User>;
  adminSearchAlphaAllowList: Array<AlphaAllowListEntry>;
  health: Scalars['String']['output'];
};


export type QueryAdminGetBankConnectionsHealthArgs = {
  userId: Scalars['String']['input'];
};


export type QueryAdminGetFeatureGateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminGetFeatureGateByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryAdminGetLatestTransactionMerchantStatisticsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryAdminGetLatestTransactionStatisticsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryAdminGetProcessorStatusesArgs = {
  filters?: InputMaybe<ProcessorStatusFilters>;
  pagination: PaginationInput;
};


export type QueryAdminGetTransactionPairsForUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryAdminGetTransactionsForUserArgs = {
  filters?: InputMaybe<TransactionFilters>;
  pagination: PaginationInput;
  sortKey?: InputMaybe<TransactionSortKeys>;
  userId: Scalars['String']['input'];
};


export type QueryAdminGetUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminGetUserBankConnectionsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryAdminListBillSubmissionsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdminListBillsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdminListMerchantsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdminListRecurringTransactionsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdminSearchAlphaAllowListArgs = {
  query: Scalars['String']['input'];
};

export type RecurringTransaction = INode & {
  __typename?: 'RecurringTransaction';
  amountRange: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  firstOccurrence: Scalars['CalendarDate']['output'];
  frequency: RecurringTransactionFrequency;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  latestOccurrence: Scalars['CalendarDate']['output'];
  nextOccurrence?: Maybe<Scalars['CalendarDate']['output']>;
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
  type: RecurringTransactionType;
};

export enum RecurringTransactionFrequency {
  Annually = 'ANNUALLY',
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  SemiMonthly = 'SEMI_MONTHLY',
  Unknown = 'UNKNOWN',
  Weekly = 'WEEKLY'
}

export enum RecurringTransactionType {
  Bill = 'BILL',
  Income = 'INCOME',
  Subscription = 'SUBSCRIPTION'
}

export type Release = {
  __typename?: 'Release';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  githubAuthorLogin?: Maybe<Scalars['String']['output']>;
  mopsAuthorEmail?: Maybe<Scalars['String']['output']>;
  sha: Scalars['String']['output'];
  tag: Scalars['ID']['output'];
};

export type ReleaseChangeLog = {
  __typename?: 'ReleaseChangeLog';
  baseSha: Scalars['String']['output'];
  baseTag: Scalars['String']['output'];
  ciStatus: ReleaseCiStatus;
  commits: Array<ReleaseCommit>;
  computedNextTag: Scalars['String']['output'];
  headSha: Scalars['String']['output'];
};

export type ReleaseCiStatus = {
  __typename?: 'ReleaseCiStatus';
  conclusion: Scalars['String']['output'];
  failureCount: Scalars['Float']['output'];
  pendingCount: Scalars['Float']['output'];
  successCount: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export type ReleaseCommit = {
  __typename?: 'ReleaseCommit';
  author?: Maybe<Scalars['String']['output']>;
  authoredAt: Scalars['DateTimeISO']['output'];
  body?: Maybe<Scalars['String']['output']>;
  prNumber?: Maybe<Scalars['Float']['output']>;
  prUrl?: Maybe<Scalars['String']['output']>;
  sha: Scalars['String']['output'];
  shortSha: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type ReleaseDraft = {
  __typename?: 'ReleaseDraft';
  body: Scalars['String']['output'];
  draftedAt: Scalars['DateTimeISO']['output'];
  draftedByEmail: Scalars['String']['output'];
  htmlUrl: Scalars['String']['output'];
  tag: Scalars['ID']['output'];
  targetSha: Scalars['String']['output'];
};

export type ReleasePrerequisite = {
  __typename?: 'ReleasePrerequisite';
  prNumbers: Array<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
};

export type ReleasePreview = {
  __typename?: 'ReleasePreview';
  baseSha: Scalars['String']['output'];
  baseTag: Scalars['String']['output'];
  ciStatus: ReleaseCiStatus;
  commits: Array<ReleaseCommit>;
  computedNextTag: Scalars['String']['output'];
  expectedHeadSha: Scalars['String']['output'];
  headSha: Scalars['String']['output'];
  prerequisites: Array<ReleasePrerequisite>;
  riskCallouts: Array<Scalars['String']['output']>;
  summary: Array<Scalars['String']['output']>;
  testPlan: Array<ReleaseTestPlanItem>;
};

export type ReleaseTestPlanItem = {
  __typename?: 'ReleaseTestPlanItem';
  action: Scalars['String']['output'];
  expectedResult: Scalars['String']['output'];
};

export type Transaction = INode & {
  __typename?: 'Transaction';
  amount: Scalars['String']['output'];
  anomalyDetection?: Maybe<TransactionAnomalyDetection>;
  anomalyFeedback?: Maybe<TransactionAnomalyFeedback>;
  category: TransactionCategory;
  date: Scalars['CalendarDate']['output'];
  description: Scalars['String']['output'];
  financialAccount?: Maybe<FinancialAccount>;
  id: Scalars['ID']['output'];
  isPending: Scalars['Boolean']['output'];
  isUnverified: Scalars['Boolean']['output'];
  merchant?: Maybe<Merchant>;
  pairedTransaction?: Maybe<Transaction>;
  rawDescription?: Maybe<Scalars['String']['output']>;
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
};

export enum TransactionAmountType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type TransactionAnomalyDetection = INode & {
  __typename?: 'TransactionAnomalyDetection';
  anomalyReasons: Array<Scalars['String']['output']>;
  anomalyScore: Scalars['Float']['output'];
  featuresJson: Scalars['JSONObject']['output'];
  id: Scalars['ID']['output'];
  scoreParts: AnomalyScoreParts;
};

export type TransactionAnomalyFeedback = INode & {
  __typename?: 'TransactionAnomalyFeedback';
  detailedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  priority: TransactionAnomalyPriority;
};

/** Priority level for transaction anomaly feedback */
export enum TransactionAnomalyPriority {
  P0 = 'P0',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4'
}

export type TransactionCategory = INode & {
  __typename?: 'TransactionCategory';
  detailedType?: Maybe<TransactionCategoryDetailedType>;
  id: Scalars['ID']['output'];
  type: TransactionCategoryPrimaryType;
};

export enum TransactionCategoryDetailedType {
  BankFeesAtmFees = 'BANK_FEES_ATM_FEES',
  BankFeesForeignTransactionFees = 'BANK_FEES_FOREIGN_TRANSACTION_FEES',
  BankFeesInsufficientFunds = 'BANK_FEES_INSUFFICIENT_FUNDS',
  BankFeesInterestCharge = 'BANK_FEES_INTEREST_CHARGE',
  BankFeesOtherBankFees = 'BANK_FEES_OTHER_BANK_FEES',
  BankFeesOverdraftFees = 'BANK_FEES_OVERDRAFT_FEES',
  EntertainmentCasinosAndGambling = 'ENTERTAINMENT_CASINOS_AND_GAMBLING',
  EntertainmentMusicAndAudio = 'ENTERTAINMENT_MUSIC_AND_AUDIO',
  EntertainmentOtherEntertainment = 'ENTERTAINMENT_OTHER_ENTERTAINMENT',
  EntertainmentSportingEventsAmusementParksAndMuseums = 'ENTERTAINMENT_SPORTING_EVENTS_AMUSEMENT_PARKS_AND_MUSEUMS',
  EntertainmentTvAndMovies = 'ENTERTAINMENT_TV_AND_MOVIES',
  EntertainmentVideoGames = 'ENTERTAINMENT_VIDEO_GAMES',
  FoodAndDrinkBeerWineAndLiquor = 'FOOD_AND_DRINK_BEER_WINE_AND_LIQUOR',
  FoodAndDrinkCoffee = 'FOOD_AND_DRINK_COFFEE',
  FoodAndDrinkFastFood = 'FOOD_AND_DRINK_FAST_FOOD',
  FoodAndDrinkGroceries = 'FOOD_AND_DRINK_GROCERIES',
  FoodAndDrinkOtherFoodAndDrink = 'FOOD_AND_DRINK_OTHER_FOOD_AND_DRINK',
  FoodAndDrinkRestaurant = 'FOOD_AND_DRINK_RESTAURANT',
  FoodAndDrinkVendingMachines = 'FOOD_AND_DRINK_VENDING_MACHINES',
  GeneralMerchandiseBookstoresAndNewsstands = 'GENERAL_MERCHANDISE_BOOKSTORES_AND_NEWSSTANDS',
  GeneralMerchandiseClothingAndAccessories = 'GENERAL_MERCHANDISE_CLOTHING_AND_ACCESSORIES',
  GeneralMerchandiseConvenienceStores = 'GENERAL_MERCHANDISE_CONVENIENCE_STORES',
  GeneralMerchandiseDepartmentStores = 'GENERAL_MERCHANDISE_DEPARTMENT_STORES',
  GeneralMerchandiseDiscountStores = 'GENERAL_MERCHANDISE_DISCOUNT_STORES',
  GeneralMerchandiseElectronics = 'GENERAL_MERCHANDISE_ELECTRONICS',
  GeneralMerchandiseGiftsAndNovelties = 'GENERAL_MERCHANDISE_GIFTS_AND_NOVELTIES',
  GeneralMerchandiseOfficeSupplies = 'GENERAL_MERCHANDISE_OFFICE_SUPPLIES',
  GeneralMerchandiseOnlineMarketplaces = 'GENERAL_MERCHANDISE_ONLINE_MARKETPLACES',
  GeneralMerchandiseOtherGeneralMerchandise = 'GENERAL_MERCHANDISE_OTHER_GENERAL_MERCHANDISE',
  GeneralMerchandisePetSupplies = 'GENERAL_MERCHANDISE_PET_SUPPLIES',
  GeneralMerchandiseSportingGoods = 'GENERAL_MERCHANDISE_SPORTING_GOODS',
  GeneralMerchandiseSuperstores = 'GENERAL_MERCHANDISE_SUPERSTORES',
  GeneralMerchandiseTobaccoAndVape = 'GENERAL_MERCHANDISE_TOBACCO_AND_VAPE',
  GeneralServicesAccountingAndFinancialPlanning = 'GENERAL_SERVICES_ACCOUNTING_AND_FINANCIAL_PLANNING',
  GeneralServicesAutomotive = 'GENERAL_SERVICES_AUTOMOTIVE',
  GeneralServicesChildcare = 'GENERAL_SERVICES_CHILDCARE',
  GeneralServicesConsultingAndLegal = 'GENERAL_SERVICES_CONSULTING_AND_LEGAL',
  GeneralServicesEducation = 'GENERAL_SERVICES_EDUCATION',
  GeneralServicesInsurance = 'GENERAL_SERVICES_INSURANCE',
  GeneralServicesOtherGeneralServices = 'GENERAL_SERVICES_OTHER_GENERAL_SERVICES',
  GeneralServicesPostageAndShipping = 'GENERAL_SERVICES_POSTAGE_AND_SHIPPING',
  GeneralServicesStorage = 'GENERAL_SERVICES_STORAGE',
  GovernmentAndNonProfitDonations = 'GOVERNMENT_AND_NON_PROFIT_DONATIONS',
  GovernmentAndNonProfitGovernmentDepartmentsAndAgencies = 'GOVERNMENT_AND_NON_PROFIT_GOVERNMENT_DEPARTMENTS_AND_AGENCIES',
  GovernmentAndNonProfitOtherGovernmentAndNonProfit = 'GOVERNMENT_AND_NON_PROFIT_OTHER_GOVERNMENT_AND_NON_PROFIT',
  GovernmentAndNonProfitTaxPayment = 'GOVERNMENT_AND_NON_PROFIT_TAX_PAYMENT',
  HomeImprovementFurniture = 'HOME_IMPROVEMENT_FURNITURE',
  HomeImprovementHardware = 'HOME_IMPROVEMENT_HARDWARE',
  HomeImprovementOtherHomeImprovement = 'HOME_IMPROVEMENT_OTHER_HOME_IMPROVEMENT',
  HomeImprovementRepairAndMaintenance = 'HOME_IMPROVEMENT_REPAIR_AND_MAINTENANCE',
  HomeImprovementSecurity = 'HOME_IMPROVEMENT_SECURITY',
  IncomeDividends = 'INCOME_DIVIDENDS',
  IncomeInterestEarned = 'INCOME_INTEREST_EARNED',
  IncomeOtherIncome = 'INCOME_OTHER_INCOME',
  IncomeRetirementPension = 'INCOME_RETIREMENT_PENSION',
  IncomeTaxRefund = 'INCOME_TAX_REFUND',
  IncomeUnemployment = 'INCOME_UNEMPLOYMENT',
  IncomeWages = 'INCOME_WAGES',
  LoanPaymentsCarPayment = 'LOAN_PAYMENTS_CAR_PAYMENT',
  LoanPaymentsCreditCardPayment = 'LOAN_PAYMENTS_CREDIT_CARD_PAYMENT',
  LoanPaymentsMortgagePayment = 'LOAN_PAYMENTS_MORTGAGE_PAYMENT',
  LoanPaymentsOtherPayment = 'LOAN_PAYMENTS_OTHER_PAYMENT',
  LoanPaymentsPersonalLoanPayment = 'LOAN_PAYMENTS_PERSONAL_LOAN_PAYMENT',
  LoanPaymentsStudentLoanPayment = 'LOAN_PAYMENTS_STUDENT_LOAN_PAYMENT',
  MedicalDentalCare = 'MEDICAL_DENTAL_CARE',
  MedicalEyeCare = 'MEDICAL_EYE_CARE',
  MedicalNursingCare = 'MEDICAL_NURSING_CARE',
  MedicalOtherMedical = 'MEDICAL_OTHER_MEDICAL',
  MedicalPharmaciesAndSupplements = 'MEDICAL_PHARMACIES_AND_SUPPLEMENTS',
  MedicalPrimaryCare = 'MEDICAL_PRIMARY_CARE',
  MedicalVeterinaryServices = 'MEDICAL_VETERINARY_SERVICES',
  Other = 'OTHER',
  PersonalCareGymsAndFitnessCenters = 'PERSONAL_CARE_GYMS_AND_FITNESS_CENTERS',
  PersonalCareHairAndBeauty = 'PERSONAL_CARE_HAIR_AND_BEAUTY',
  PersonalCareLaundryAndDryCleaning = 'PERSONAL_CARE_LAUNDRY_AND_DRY_CLEANING',
  PersonalCareOtherPersonalCare = 'PERSONAL_CARE_OTHER_PERSONAL_CARE',
  RentAndUtilitiesGasAndElectricity = 'RENT_AND_UTILITIES_GAS_AND_ELECTRICITY',
  RentAndUtilitiesInternetAndCable = 'RENT_AND_UTILITIES_INTERNET_AND_CABLE',
  RentAndUtilitiesOtherUtilities = 'RENT_AND_UTILITIES_OTHER_UTILITIES',
  RentAndUtilitiesRent = 'RENT_AND_UTILITIES_RENT',
  RentAndUtilitiesSewageAndWasteManagement = 'RENT_AND_UTILITIES_SEWAGE_AND_WASTE_MANAGEMENT',
  RentAndUtilitiesTelephone = 'RENT_AND_UTILITIES_TELEPHONE',
  RentAndUtilitiesWater = 'RENT_AND_UTILITIES_WATER',
  TransferInAccountTransfer = 'TRANSFER_IN_ACCOUNT_TRANSFER',
  TransferInCashAdvancesAndLoans = 'TRANSFER_IN_CASH_ADVANCES_AND_LOANS',
  TransferInDeposit = 'TRANSFER_IN_DEPOSIT',
  TransferInInvestmentAndRetirementFunds = 'TRANSFER_IN_INVESTMENT_AND_RETIREMENT_FUNDS',
  TransferInOtherTransferIn = 'TRANSFER_IN_OTHER_TRANSFER_IN',
  TransferInSavings = 'TRANSFER_IN_SAVINGS',
  TransferOutAccountTransfer = 'TRANSFER_OUT_ACCOUNT_TRANSFER',
  TransferOutInvestmentAndRetirementFunds = 'TRANSFER_OUT_INVESTMENT_AND_RETIREMENT_FUNDS',
  TransferOutOtherTransferOut = 'TRANSFER_OUT_OTHER_TRANSFER_OUT',
  TransferOutSavings = 'TRANSFER_OUT_SAVINGS',
  TransferOutWithdrawal = 'TRANSFER_OUT_WITHDRAWAL',
  TransportationBikesAndScooters = 'TRANSPORTATION_BIKES_AND_SCOOTERS',
  TransportationGas = 'TRANSPORTATION_GAS',
  TransportationOtherTransportation = 'TRANSPORTATION_OTHER_TRANSPORTATION',
  TransportationParking = 'TRANSPORTATION_PARKING',
  TransportationPublicTransit = 'TRANSPORTATION_PUBLIC_TRANSIT',
  TransportationTaxisAndRideShares = 'TRANSPORTATION_TAXIS_AND_RIDE_SHARES',
  TransportationTolls = 'TRANSPORTATION_TOLLS',
  TravelFlights = 'TRAVEL_FLIGHTS',
  TravelLodging = 'TRAVEL_LODGING',
  TravelOtherTravel = 'TRAVEL_OTHER_TRAVEL',
  TravelRentalCars = 'TRAVEL_RENTAL_CARS'
}

export enum TransactionCategoryPrimaryType {
  BankFees = 'BANK_FEES',
  Entertainment = 'ENTERTAINMENT',
  FoodAndDrink = 'FOOD_AND_DRINK',
  GeneralMerchandise = 'GENERAL_MERCHANDISE',
  GeneralServices = 'GENERAL_SERVICES',
  GovernmentAndNonProfit = 'GOVERNMENT_AND_NON_PROFIT',
  HomeImprovement = 'HOME_IMPROVEMENT',
  Income = 'INCOME',
  LoanPayments = 'LOAN_PAYMENTS',
  Medical = 'MEDICAL',
  Other = 'OTHER',
  PersonalCare = 'PERSONAL_CARE',
  RentAndUtilities = 'RENT_AND_UTILITIES',
  TransferIn = 'TRANSFER_IN',
  TransferOut = 'TRANSFER_OUT',
  Transportation = 'TRANSPORTATION',
  Travel = 'TRAVEL',
  Unknown = 'UNKNOWN'
}

export type TransactionConnection = ITransactionConnection & {
  __typename?: 'TransactionConnection';
  edges: Array<TransactionEdge>;
  pageInfo: PageInfo;
};

export type TransactionEdge = ITransactionEdge & {
  __typename?: 'TransactionEdge';
  cursor: Scalars['String']['output'];
  node: Transaction;
};

export type TransactionFilters = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  excludePaired?: InputMaybe<Scalars['Boolean']['input']>;
  financialAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  merchantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  recurringTransactionId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<TransactionSearchFilter>;
  startDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  transactionAmountType?: InputMaybe<TransactionAmountType>;
};

export type TransactionMerchantStatistics = INode & {
  __typename?: 'TransactionMerchantStatistics';
  endDate: Scalars['CalendarDate']['output'];
  id: Scalars['ID']['output'];
  merchant?: Maybe<Merchant>;
  startDate: Scalars['CalendarDate']['output'];
  statsJson: Scalars['JSONObject']['output'];
};

export type TransactionPair = INode & {
  __typename?: 'TransactionPair';
  creditTransaction: Transaction;
  debitTransaction: Transaction;
  id: Scalars['ID']['output'];
  pairType: TransactionPairType;
};

export enum TransactionPairType {
  CreditCardPayment = 'CREDIT_CARD_PAYMENT',
  Transfer = 'TRANSFER'
}

export type TransactionSearchFilter = {
  query: Scalars['String']['input'];
  types: Array<TransactionSearchType>;
};

export enum TransactionSearchType {
  FinancialAccount = 'FINANCIAL_ACCOUNT',
  Merchant = 'MERCHANT'
}

export enum TransactionSortKeys {
  Amount = 'AMOUNT',
  Date = 'DATE'
}

export type TransactionStatistics = INode & {
  __typename?: 'TransactionStatistics';
  endDate: Scalars['CalendarDate']['output'];
  id: Scalars['ID']['output'];
  startDate: Scalars['CalendarDate']['output'];
  statsJson: Scalars['JSONObject']['output'];
};

export type UpdateFeatureGateInput = {
  defaultWhenError?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ruleTree?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type User = IEntity & INode & {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type UserWithTransactionReviewCount = {
  __typename?: 'UserWithTransactionReviewCount';
  transactionReviewCount: Scalars['Float']['output'];
  user: User;
};
